import React, { useState } from 'react';
import Icon from './Icon';

const Input = ({
  label,
  name,
  type     = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  icon,
  className = '',
  autoComplete,
}) => {
  const [showPwd, setShowPwd] = useState(false);
  const isPassword = type === 'password';
  const inputType  = isPassword ? (showPwd ? 'text' : 'password') : type;

  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="text-xs font-dm font-medium text-surface-100 uppercase tracking-wider"
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-surface-300 pointer-events-none">
            <Icon name={icon} size={17} />
          </span>
        )}

        <input
          id={name}
          name={name}
          type={inputType}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          className={[
            'w-full h-[52px] rounded-2xl bg-surface-600 border text-sm font-dm text-slate-800',
            'transition-all duration-200 focus:outline-none',
            icon ? 'pl-11 pr-4' : 'px-4',
            isPassword ? 'pr-12' : '',
            error
              ? 'border-rose-400 focus:border-rose-500 focus:ring-2 focus:ring-rose-500/15'
              : 'border-surface-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-500/15',
          ].join(' ')}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPwd((p) => !p)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-surface-300 hover:text-slate-700 transition-colors"
          >
            <Icon name={showPwd ? 'eyeOff' : 'eye'} size={17} />
          </button>
        )}
      </div>

      {error && (
        <p className="text-xs text-rose-500 font-dm flex items-center gap-1">
          <span>⚠</span> {error}
        </p>
      )}
    </div>
  );
};

export default Input;
